module.exports = __webpack_public_path__ + "static/15-7270c0fbc8d7fac9b39a697aae8a1780.png";